import { Inject, Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { v4 as uuid } from 'uuid';
import { environment } from 'src/environments/environment';
import {
  ITokenStorageRepository,
  TOKEN_STORAGE_REPOSITORY,
} from '@modules/auth';

@Injectable()
export class AppHttpInterceptor implements HttpInterceptor {
  constructor(
    @Inject(TOKEN_STORAGE_REPOSITORY)
    private readonly tokenStorage: ITokenStorageRepository,
  ) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler,
  ): Observable<HttpEvent<any>> {
    const token = this.tokenStorage.getToken();

    req = req.clone({
      headers: req.headers
        .set('app-code', `${environment.appName}`)
        .set('Request-ID', uuid())
        .set('request-date', new Date().toISOString())
        .set('Authorization', `Bearer ${token}`)
        .set('Ocp-Apim-Subscription-Key', environment.apiSubscriptionKey),
    });
    return next.handle(req);
  }
}
